var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoBrandConinsainline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200.972 42.761",
    id: "co-brand-coninsa_inline_svg__svg114"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "co-brand-coninsa_inline_svg__defs76"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style74"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "co-brand-coninsa_inline_svg__g164",
    transform: "translate(-29.225 -14.084)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.772 -8.914)",
    id: "co-brand-coninsa_inline_svg__g112"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(37 9)",
    id: "co-brand-coninsa_inline_svg__rect78",
    fill: "none",
    d: "M0 0h259v71H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120.594 -35.209)",
    id: "co-brand-coninsa_inline_svg__g110"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#22376c",
    d: "M259.228 85.493v14.544h-9.438V72.374h9.438v4.334A5.961 5.961 0 01262.345 73 9.812 9.812 0 01267 71.662q5.461 0 8.252 3.532 2.791 3.532 2.789 10.122v14.722h-9.438V85.612a4.531 4.531 0 00-1.365-3.651A4.727 4.727 0 00264.1 80.8a5.446 5.446 0 00-3.384 1.127 4.187 4.187 0 00-1.485 3.562",
    transform: "translate(1.777 .378)",
    id: "co-brand-coninsa_inline_svg__path80"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22376c",
    d: "M282.729 100.415h9.438V72.752h-9.438zm-1.01-36.864a4.943 4.943 0 011.692-3.8 5.746 5.746 0 014.007-1.543 5.617 5.617 0 014.008 1.543 5.025 5.025 0 011.632 3.8 5.116 5.116 0 01-1.632 3.829 5.556 5.556 0 01-4.008 1.573 5.631 5.631 0 01-4.007-1.6 5.06 5.06 0 01-1.692-3.8",
    transform: "translate(2.675)",
    id: "co-brand-coninsa_inline_svg__path82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22376c",
    d: "M307.093 85.493v14.544h-9.438V72.374h9.438v4.334A5.959 5.959 0 01310.209 73a9.819 9.819 0 014.66-1.336q5.461 0 8.252 3.532 2.791 3.532 2.789 10.122v14.722h-9.438V85.612a4.531 4.531 0 00-1.365-3.651 4.728 4.728 0 00-3.147-1.161 5.445 5.445 0 00-3.383 1.127 4.187 4.187 0 00-1.485 3.562",
    transform: "translate(3.123 .378)",
    id: "co-brand-coninsa_inline_svg__path84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22376c",
    d: "M341.53 90.183l-3.5-.95a15.9 15.9 0 01-4.185-1.721 12.457 12.457 0 01-2.582-1.96 5.994 5.994 0 01-1.277-2.2 7.97 7.97 0 01-.475-1.9q-.031-.594-.03-1.544 0-3.2 3.355-5.728a12.807 12.807 0 017.925-2.524 18.255 18.255 0 014.363.5 14.348 14.348 0 013.859 1.573 7.582 7.582 0 012.849 3 9.324 9.324 0 011.039 4.483h-8.846q0-2.494-2.789-2.493-2.315 0-2.315 1.543 0 1.306 2.078 1.781l4.927 1.365a13.362 13.362 0 014.185 1.811 7.13 7.13 0 012.374 2.463 10.669 10.669 0 01.92 2.256 7.63 7.63 0 01.237 1.84 7.174 7.174 0 01-3.8 6.53 16.755 16.755 0 01-8.727 2.257 13.957 13.957 0 01-8.4-2.642 8.374 8.374 0 01-3.651-7.153h8.845a2.866 2.866 0 00.8 1.959 3.071 3.071 0 002.4.89 3.97 3.97 0 002.048-.5 1.509 1.509 0 00.861-1.336.982.982 0 00-.475-.89 8.918 8.918 0 00-2.018-.712",
    transform: "translate(4.006 .378)",
    id: "co-brand-coninsa_inline_svg__path86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22376c",
    d: "M367.683 94.16a5.914 5.914 0 003.324-1.069 5.413 5.413 0 002.2-2.789 7.687 7.687 0 00-4.927-1.425 3.553 3.553 0 00-2.731.861 2.685 2.685 0 00-.772 1.811 2.727 2.727 0 00.742 1.722 2.662 2.662 0 002.167.89m-5.64-11.932l-4.99-4.929q4.036-5.64 12.763-5.639a14.306 14.306 0 019.29 3q3.709 3 3.71 8.933v16.444h-9.439v-2.969a8.188 8.188 0 01-3.413 2.611 10.287 10.287 0 01-4.007.891 11.987 11.987 0 01-7.777-2.315 8 8 0 01-2.849-6.589 6.953 6.953 0 013.086-6.026 14.109 14.109 0 018.252-2.166 13.217 13.217 0 016.589 1.484v-.831a4.287 4.287 0 00-1.513-3.354 5.021 5.021 0 00-3.413-1.336 7.639 7.639 0 00-6.293 2.789",
    transform: "translate(4.745 .378)",
    id: "co-brand-coninsa_inline_svg__path88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22376c",
    d: "M205.716 89.029a5.938 5.938 0 01-.825 1.034 5.626 5.626 0 110-7.945 5.7 5.7 0 011.15 1.634l8.967-1.308a12.788 12.788 0 00-3.854-6.56 14.545 14.545 0 00-10.236-3.944 14.271 14.271 0 00-10.118 3.944 13.359 13.359 0 00-4.2 10.207 13.288 13.288 0 004.2 10.15 14.266 14.266 0 0010.121 3.944 14.541 14.541 0 0010.236-3.944 12.789 12.789 0 003.682-5.881z",
    transform: "translate(0 .386)",
    id: "co-brand-coninsa_inline_svg__path90"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87bc28",
    d: "M226.562 82.052l-.007.011.007-.011",
    transform: "translate(1.124 .67)",
    id: "co-brand-coninsa_inline_svg__path94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87bc28",
    d: "M226.521 82.113",
    transform: "translate(1.123 .672)",
    id: "co-brand-coninsa_inline_svg__path96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87bc28",
    d: "M229.461 91.867a6.506 6.506 0 01-3.767-5.9c0-.088 0-.176.005-.263v-.093c0-.081.01-.162.018-.243a12.888 12.888 0 0112.844-11.825q.509 0 1.009.039a15.038 15.038 0 00-7.328-1.783 14.471 14.471 0 00-10.266 4.009 13.008 13.008 0 00-3.786 6.392 12.4 12.4 0 0011.271 9.666",
    transform: "translate(.888 .382)",
    id: "co-brand-coninsa_inline_svg__path98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc100",
    d: "M225.516 85.319a6.507 6.507 0 119.284 6.471l1.2 8.136a14.6 14.6 0 006.448-3.526 13.4 13.4 0 004.317-10.3 13.466 13.466 0 00-4.332-10.354 15.276 15.276 0 00-3.061-2.21q-.5-.039-1.009-.039a12.888 12.888 0 00-12.844 11.825",
    transform: "translate(1.094 .43)",
    id: "co-brand-coninsa_inline_svg__path100"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc100",
    d: "M225.5 85.257v.068l.005-.094v.025",
    transform: "translate(1.094 .76)",
    id: "co-brand-coninsa_inline_svg__path102"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d4102a",
    d: "M243.326 89.812c0-5.783-4.974-10.481-11.14-10.552a6.508 6.508 0 012.43 12.368l1.193 8.133a10.627 10.627 0 007.517-9.95",
    transform: "translate(1.282 .592)",
    id: "co-brand-coninsa_inline_svg__path104"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00993c",
    d: "M229.526 91.607l-.052-.025a12.4 12.4 0 01-11.274-9.659v-.007.006a16.027 16.027 0 00-.467 3.959 13.482 13.482 0 004.273 10.3 14.33 14.33 0 006.344 3.51z",
    transform: "translate(.876 .667)",
    id: "co-brand-coninsa_inline_svg__path106"
  }))))));
}

export default SvgCoBrandConinsainline;